import styles from "./HelpText.module.scss";
import { GET_HELP_LINK } from "@constants/common";

const HelpText = () => {
  //getting locale

  return (
    <div className={styles["help-panel"]}>
      <span>
        {" "}
        Need help? Contact us via
      </span>{" "}
      <a href={GET_HELP_LINK.EN} target="_blank" rel="noreferrer">
        Help Center
      </a>
    </div>
  );
};

export default HelpText;
